// Product vocabulary. One definition each for the two names users read, so the
// next rename is a one-line change here rather than another repo-wide audit.
//
// FEATURE_NAME is the section, the place, the tool: sidebar entry, page heading,
// browser title, and any sentence that points a user AT the feature.
// OBJECT_NOUN is one instance — the thing a person sends another person.
//
// The test for which applies: if you could substitute "the section" it is
// FEATURE_NAME; if you could substitute "a thing someone sent you" it is
// OBJECT_NOUN. "Go to Trade Builder" is the feature. "Turn trade offers back
// on" is the object, and every string already written that way stays as it is.
//
// NOT for identifiers. The URL (/trade-offers), the RTK Query cache tags
// ('Offers'/'Offer'), error codes, API fields and CSS class names are
// deliberately unchanged — the label moves, the machine does not. Note the
// cache tag literal is byte-identical to what the sidebar used to say, so a
// find-and-replace over "Offers" breaks invalidation silently; change call
// sites by hand.

export const FEATURE_NAME = 'Trade Builder';

// Exported for the definition's sake and for new copy to reach for. Existing
// object-noun strings are deliberately NOT refactored to interpolate this:
// they are already correct, and rewriting ~45 correct strings to prove a point
// is exactly the churn this ticket rules out.
export const OBJECT_NOUN = 'trade offer';
export const OBJECT_NOUN_PLURAL = 'trade offers';
